module.exports = __webpack_public_path__ + "img/f-o-s.eb6ca625.png";